import moment from 'moment';
import HelperMixin from '../../Shared/HelperMixin.vue';
import PaginationHelper from '../../Shared/PaginationHelper.vue';

// NOT-13 — User-submitted incident reports queue.
// Backed by ReportsController.cs (api/admin/Reports). Status codes:
//   1 New | 2 Assigned | 3 Replied | 5 Resolved | 6 Dismissed | 7 Escalated

export default {
    name: 'Reports',
    mixins: [HelperMixin],
    components: { PaginationHelper },

    filters: {
        moment(d) {
            if (!d) return '—';
            return moment(d).format('DD/MM/YYYY HH:mm');
        }
    },

    async created() {
        this.loginDetails = await this.CheckLoginStatus();
        if (!this.requireUserType([1])) return;
        await this.LoadStats();
        await this.Load();
    },

    data() {
        return {
            Items: [],
            Stats: null,
            StatusFilter: '',
            pageNo: 1,
            pageSize: 20,
            totalCount: 0,
            // Audit P1 #6 — detail thread + reply modal state.
            Detail: null,        // full report incl. messages, loaded on demand
            DetailLoading: false,
            ReplyText: '',
            ReplyInternal: false,
            Sending: false,
        };
    },

    methods: {
        StatusLabel(s) {
            if (s === 1) return 'جديد';
            if (s === 2) return 'مُسند';
            if (s === 3) return 'تم الرد';
            if (s === 5) return 'محلول';
            if (s === 6) return 'مرفوض';
            if (s === 7) return 'مُصعَّد';
            return '—';
        },
        StatusClass(s) {
            if (s === 1) return 'pill-new';
            if (s === 2) return 'pill-assigned';
            if (s === 3) return 'pill-replied';
            if (s === 5) return 'pill-resolved';
            if (s === 6) return 'pill-dismissed';
            if (s === 7) return 'pill-escalated';
            return '';
        },
        async LoadStats() {
            try {
                const res = await this.$http.GetReportsStats();
                this.Stats = res.data || null;
            } catch (e) {
                this.Stats = null;
            }
        },
        async Load(pageNo) {
            this.pageNo = pageNo || 1;
            this.$blockUI.Start();
            try {
                const res = await this.$http.GetReportsQueue(this.pageNo, this.pageSize, this.StatusFilter);
                const data = res.data || {};
                this.Items = data.items || data.info || [];
                this.totalCount = data.total || data.count || this.Items.length;
            } catch (e) {
                this.Items = [];
                this.totalCount = 0;
            } finally {
                this.$blockUI.Stop();
            }
        },
        async OpenDetail(it) {
            // Audit P1 #6 — real thread view (was an alert placeholder). Loads
            // the full report incl. message history, lets the admin reply via
            // the existing ReportsController Reply endpoint.
            this.Detail = { id: it.id, subject: it.subject || it.title || '—' };
            this.DetailLoading = true;
            this.ReplyText = '';
            this.ReplyInternal = false;
            try {
                const res = await this.$http.GetReportDetail(it.id);
                this.Detail = res.data || null;
            } catch (e) {
                this.Detail = null;
                const msg = (e && e.response && e.response.status === 404) ? 'البلاغ غير موجود' : 'تعذّر تحميل البلاغ';
                if (this.$helper && this.$helper.FailMessage) this.$helper.FailMessage(msg); else alert(msg);
            } finally {
                this.DetailLoading = false;
            }
        },
        CloseDetail() {
            this.Detail = null;
            this.ReplyText = '';
        },
        SenderLabel(m) {
            // senderRole: admin family (1/40/41) vs the reporter. Internal notes flagged.
            if (m && m.isInternal) return 'ملاحظة داخلية';
            const r = m ? m.senderRole : null;
            if (r === 1 || r === 40 || r === 41) return 'الإدارة';
            return 'المُبلِّغ';
        },
        async SendReply() {
            const text = (this.ReplyText || '').trim();
            if (!text || this.Sending || !this.Detail) return;
            this.Sending = true;
            try {
                await this.$http.ReplyReport(this.Detail.id, text, this.ReplyInternal);
                this.ReplyText = '';
                // Reload thread so the new message + status change show.
                const res = await this.$http.GetReportDetail(this.Detail.id);
                this.Detail = res.data || this.Detail;
                this.Load(this.pageNo);   // refresh queue status pill
                this.LoadStats();
            } catch (e) {
                const msg = (e && e.response && e.response.data && e.response.data.Message) || 'تعذّر إرسال الرد';
                if (this.$helper && this.$helper.FailMessage) this.$helper.FailMessage(msg); else alert(msg);
            } finally {
                this.Sending = false;
            }
        },
        async QuickResolve(id, status) {
            try {
                await this.$http.ResolveReport(id, 'تم الحل من اللوحة', status);
                this.Load(this.pageNo);
                this.LoadStats();
            } catch (e) {
                const msg = e?.response?.data?.Message || 'تعذّر إغلاق البلاغ';
                if (this.$helper && this.$helper.FailMessage) this.$helper.FailMessage(msg);
                else alert(msg);
            }
        }
    }
};
